import Link from "next/link";

interface NavLinksProps {
  links: { href: string; label: string }[];
  className?: string;
  onClick?: () => void;
}

export default function NavLinks({ links, className, onClick }: NavLinksProps) {
  return (
    <>
      {links.map((link) => (
        <Link
          key={link.href}
          href={link.href}
          className={className}
          onClick={onClick}
        >
          {link.label}
        </Link>
      ))}
    </>
  );
}
